

/**
 * Directive to force text to fit using ellipsis
 * Inspired by http://jsfiddle.net/brebey/1q94gLsu/6/
 * 
 * text-to-fit: the text that will be rendered to fit
 * fit-to-width (ignored if using use-element-width): a static pixel width to constrain by
 * use-element-width (ignored if using fit-to-width): calculate the element's width, constrain by that
 */
SUGApp.directive('fitEllipsis', ['$timeout','$interpolate', function ($timeout,$interpolate) {
	var getTextWidth = function (text, font) {
		var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
		var context = canvas.getContext("2d");
		context.font = font;
		var metrics = context.measureText(text);
		return metrics.width;
	};

	var processText = function (scope, element, attrs) {
		var $ele = angular.element(element);
		var strVal = scope.strVal;
		var iMaxWidth = scope.maxWidth ? scope.maxWidth : scope.useEleWidth ? $ele.width() : 0;
		var strFontWeight = $ele.css("font-weight");
		var strFontSize = $ele.css("font-size");
		var strFontFamily = $ele.css("font-family");
		var strFont = strFontWeight + " " + strFontSize + " " + strFontFamily;
		var strEllipsis = "...";
		var iFullLen = strVal.length;
		var iLen = iFullLen;
		var iWidthEllipsis = getTextWidth(strEllipsis, strFont);
		var iTruncatedMaxWidth = iMaxWidth - iWidthEllipsis;
		while (iLen > 0) {
			if (getTextWidth(strVal, strFont) <= iMaxWidth){
				break;
			}
			iMaxWidth = iTruncatedMaxWidth;
			iLen -= 1;
			strVal = strVal.substring(0, iLen - 1);
		}
		if (iLen < iFullLen){
			strVal = strVal + strEllipsis;
		}
		$timeout(function(){
			$ele.text(strVal);
		});
	};

	return {
		scope: {
			strVal: '=textToFit',
			maxWidth: '=fitToWidth',
			useEleWidth: '=useElementWidth'
		},
		link: function (scope, element, attrs) {
            processText(scope, element, attrs);
			scope.$watch('strVal',function(nval,oval){
				if(nval !== oval){
					processText(scope, element, attrs);
				}
			});
			scope.$watch('maxWidth',function(nval,oval){
				if(nval !== oval){				
					processText(scope, element, attrs);
				}
			});			
		}
	};
}]);